<tui-preview [initialScale]="0.9" [rotatable]="true">
  <tui-preview-title *ngIf="!!title">{{ title }}</tui-preview-title>

  <tui-preview-pagination [length]="images.length" [(index)]="index" />

  <button tuiIconButton tuiPreviewAction type="button" iconStart="@tui.download" (click)="download(index)"></button>

  <button tuiIconButton tuiPreviewAction type="button" iconStart="@tui.x" (click)="close.emit()"></button>

  <img alt="image" [src]="images[index].src | safe: 'resourceUrl'" />
</tui-preview>
